import { cn } from "common/utils/utils";
import { useLocation } from "react-router-dom";
import {
  FacebookShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

interface SocialShareProps {
  title: string;
  className?: string;
  isVertical?: boolean;
}

export const SocialShare = ({
  title,
  className = "",
  isVertical = false,
}: SocialShareProps) => {
  const location = useLocation();
  const currentUrl = window.location.origin + location.pathname;

  return (
    <div
      className={cn(
        "flex flex-row",
        isVertical && "flex-col",
        "items-center",
        "gap-4",
        className,
      )}
    >
      <p className="text-[20px] font-medium leading-[100%] tracking-[-0.01em] text-[#131313]">
        Share
      </p>
      <div
        className={`flex ${isVertical ? "flex-col" : "flex-row"} items-center gap-4`}
      >
        <FacebookShareButton
          url={currentUrl}
          className="h-[48px] w-[48px] cursor-pointer transition-all duration-300 hover:scale-110"
        >
          <img
            src="/assets/icons/rounded-facebook.svg"
            alt="Share on Facebook"
            className="h-full w-full"
          />
        </FacebookShareButton>
        <TwitterShareButton
          url={currentUrl}
          className="h-[48px] w-[48px] cursor-pointer transition-all duration-300 hover:scale-110"
        >
          <img
            src="/assets/icons/rounded-x.svg"
            alt="Share on Twitter"
            className="h-full w-full"
          />
        </TwitterShareButton>
        <WhatsappShareButton
          url={currentUrl}
          className="h-[48px] w-[48px] cursor-pointer transition-all duration-300 hover:scale-110"
        >
          <img
            src="/assets/icons/whatsapp.svg"
            alt="Share on WhatsApp"
            className="h-full w-full"
          />
        </WhatsappShareButton>
      </div>
    </div>
  );
};
